import { Flex, font, themedColor } from '@lemonade-hq/cdk';
import { Fragment } from 'react';
import styled from 'styled-components';
import { MediumSmallTitle } from '../shared';
import { GridCell } from './shared';

const GridContainer = styled.div`
  ${font('main', { fontSize: '1.6rem' })}
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  border: 1px solid ${themedColor('alto')};
  border-radius: 10px;
  overflow: hidden;
  text-align: center;

  & > div {
    padding: 23px 15px;
  }

  & > div:nth-last-child(-n + 2) {
    border: none;
  }
`;

const GridTitle = styled.div`
  background: ${themedColor('cloud')};
`;

const analysts = [
  { key: 'Oppenheimer', value: 'Jason Helfstein' },
  { key: 'Morgan Stanley', value: 'Bob Huang' },
  { key: 'William Blair', value: 'Adam Klauber' },
  { key: 'TD Cowen', value: 'Andrew Kligerman' },
  { key: 'Jefferies', value: 'Andrew Andersen' },
  { key: 'Dowling', value: 'Brenna Sullivan' },
  { key: 'JMP Securities', value: 'Matt Carletti' },
  { key: 'KBW', value: 'Tommy McJoynt' },
  { key: 'BMO', value: 'Michael Zaremski' },
  { key: 'FT Partners', value: 'Zachary Gunn' },
  { key: 'Cantor Fitzgerald', value: 'Ryan Tunis' },
];
export const AnalystCoverage = () => {
  return (
    <Flex flexDirection="column" width="100%" gap="18px">
      <MediumSmallTitle>Analyst Coverage</MediumSmallTitle>
      <GridContainer>
        <GridTitle>Firm</GridTitle>
        <GridTitle>Analyst</GridTitle>
        {analysts.map(item => {
          return (
            <Fragment key={item.key}>
              <GridCell align="left">{item.key}</GridCell>
              <GridCell align="right">{item.value}</GridCell>
            </Fragment>
          );
        })}
      </GridContainer>
    </Flex>
  );
};
